import { PushNotificationsService } from './push-notifications.service';

export default angular
  .module('sfMobile.services.push-notifications', [
    'sfMobile.services.user-devices',
    'sfMobile.services.firebase',
  ])
  .service('pushNotificationsService', PushNotificationsService).name;
